<template>
  <v-btn
    :color="$vuetify.breakpoint.smAndDown ? '' : 'primary'"
    :icon="$vuetify.breakpoint.smAndDown"
    :disabled="disabled"
    @click="handleSendMessageClick"
  >
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="secondary"
    />

    <v-icon v-else-if="$vuetify.breakpoint.smAndDown">
      {{ icons.mdiSend }}
    </v-icon>

    <span v-else>{{ title }}</span>
  </v-btn>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiSend } from '@mdi/js'

export default {
  props: {
    handleSendMessageClick: {
      type: Function,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
    notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas: {
      type: Boolean,
      required: true,
    },
    proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const title = computed(() => (props.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas ? 'Enviar template' : 'Enviar'))

    const disabled = computed(() => (
      !props.editavel
        || props.loading
        || props.ticketEstaFinalizado
        || props.proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas
    ))

    return {
      title,
      disabled,
      icons: {
        mdiSend,
      },
    }
  },
}
</script>
